/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface FlightModificationPolicy
 */
export interface FlightModificationPolicy {
    /**
     *
     * @type {boolean}
     * @memberof FlightModificationPolicy
     */
    allowed?: boolean | null;
    /**
     *
     * @type {number}
     * @memberof FlightModificationPolicy
     */
    penaltyAmount?: number | null;
    /**
     *
     * @type {string}
     * @memberof FlightModificationPolicy
     */
    penaltyCurrency?: string | null;
}

/**
 * Check if a given object implements the FlightModificationPolicy interface.
 */
export function instanceOfFlightModificationPolicy(value: object): value is FlightModificationPolicy {
    return true;
}

export function FlightModificationPolicyFromJSON(json: any): FlightModificationPolicy {
    return FlightModificationPolicyFromJSONTyped(json, false);
}

export function FlightModificationPolicyFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightModificationPolicy {
    if (json == null) {
        return json;
    }
    return {

        'allowed': json['allowed'] == null ? undefined : json['allowed'],
        'penaltyAmount': json['penalty_amount'] == null ? undefined : json['penalty_amount'],
        'penaltyCurrency': json['penalty_currency'] == null ? undefined : json['penalty_currency'],
    };
}

export function FlightModificationPolicyToJSON(json: any): FlightModificationPolicy {
    return FlightModificationPolicyToJSONTyped(json, false);
}

export function FlightModificationPolicyToJSONTyped(value?: FlightModificationPolicy | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'allowed': value['allowed'],
        'penalty_amount': value['penaltyAmount'],
        'penalty_currency': value['penaltyCurrency'],
    };
}
